import React from "react";

export const Page3English = () => {
  return (
    <div className="page-container">
      <p style={{ fontWeight: "bold" }}>
        "The special story of the birth of Ayyanar", which is located directly
        opposite the Adhiyannan Temple and is blessed with blessings,
      </p>
      <p>
        Bhagwan Sri Maha Sastha, who is the one who fulfills the wishes of the
        devotees who worship him quickly in the Kali Yuga, is worshipped with
        respect by the people of Tamil Nadu as Ayyanar.
      </p>
      <p>
        Once upon a time, when the ascetics living in Dharukavanam ignored the
        noble Vedas and lived in a righteous manner, Lord Shiva and Mahavishnu,
        wishing to correct them and make them live righteously, took the form of
        a witch and Mohini respectively, and performed divine pastimes and
        guided those ascetics to the right path. At that time, Lord Shiva saw
        the extraordinary beauty of the witch's form and fell in love with
        Mahavishnu, and as a result, Bhagavan Sri Maha Sastha incarnated.
      </p>
      <p>
        As soon as Bhagavan incarnated, his father Lord Shiva crowned him as
        "Bhuvaneswarar" who rules all the worlds. Since then, Bhagavan Maha
        Sastha has been the God of all the worlds and has been protecting all
        the worlds with the help of his retinues, Sri Madurai Veeranar, Sri
        Mahakalar, Sri Periyachchi, Sri Pedikkaar etc.
      </p>
      <p>
        He is worshipped by various names such as "Hariharaputra" because he was
        born as the child of Hari, Maha Vishnu, and Lord Shiva, Hara. He is also
        known as Mahasastha because he rules all the worlds, and "Denothamar"
        because he is superior to all the Brahma Devas.
      </p>
      <p>
        He married Sri Pushkalambika Devi, the princess of Nepal, and Sri
        Poornambika Devi, the princess of Vanji Desa. At another time, the
        Puranas and Agamas say that he married Sri Prabhadevi, the daughter of
        the King of Kashi, and had a daughter named Satyagar, who was endowed
        with great courage. The Mantra Shastra books praise Shasta as the
        Anukrahamurthy who binds whatever the devotees who worship him desire
        and throws it at the feet of his devotees. Further, in the Kanda Purana,
        Lord Shiva praises Bhagavan as the Triple Gem. Therefore, if we worship
        Bhagavan Sri Maha Sastha, we can achieve the great merit of worshipping
        the three great gods Brahma, Vishnu and Shiva.
      </p>
      <p>
        If we worship Ayyanar, we can get rid of the afflictions of the
        Navagrahas including Shaniswarar. Also, if we fast on Saturdays,
        Wednesdays and the Uttara Nakshatra days, which are the birth stars of
        Bhagavan, and worship Ayyanar, all our wishes will be fulfilled soon.
      </p>
     
    </div>
  );
};
